export const module = {
  info: {
    name: 'voip-mrt-dialplan',
    caption: 'MRT Dialplan',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'MRT Dialplan',
    icon: 'el-icon-folder',
    routeName: 'module->voip-mrt-dialplan->create',
    children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-mrt-dialplan->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-mrt-dialplan->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
